import { render } from "./ComparisonLossReport.vue?vue&type=template&id=56784939&scoped=true"
import script from "./ComparisonLossReport.vue?vue&type=script&lang=js"
export * from "./ComparisonLossReport.vue?vue&type=script&lang=js"

import "./ComparisonLossReport.vue?vue&type=style&index=0&id=56784939&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56784939"]])

export default __exports__
import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtnGroup,QBtn,QTooltip,QDialog});
